import { projected } from '@/services/projected.service'
import { useQuery } from '@tanstack/vue-query'

export function useProjectedSelf() {
  return useQuery({
    queryKey: ['projected-self'],
    queryFn: () => projected.show(),
    staleTime: Number.POSITIVE_INFINITY,
    cacheTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
